<!-- 企业级-业务领域-配置 -->
<template>
  <div class="mainArea CExConfigSetting">
      
        <div class="searchDiv mt20">
          <div>
            <div class="dib"><el-input placeholder="请输入设备ID" v-model="keyword.device_id" clearable></el-input></div>
            <el-button type="primary" @click="getWarehouse(1)">搜索</el-button>
          </div>
        </div>
        <el-button type="primary" class="mb20 mt20" @click="openDio('add')">添加</el-button>
        <div class="tabList">
          <el-table :data="configList" style="width: 100%" v-loading="tableLoading">
            <el-table-column type="index" label="序号" width="100"></el-table-column>
            <el-table-column prop="device_type" label="设备类型" sortable></el-table-column>
            <el-table-column prop="device_no_id" label="设备ID" sortable></el-table-column>
            <el-table-column prop="device_name" label="设备名称"></el-table-column>
            <el-table-column label="快递员">
              <template slot-scope="scope">
                <el-button type="text" @click="openDio('edit',scope.row)">{{scope.row.user_id.length}}个</el-button>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="openStatus(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="paging" v-if="total>page">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            @size-change="sizeChange"
            :page-size="page"
            :page-sizes="[10,50,100,1000]"
            layout="total,sizes,prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      <!--配置弹窗-->
      <el-dialog :title="expressTitle" :visible.sync="expressDio" width="700px" class="configDio expressDio" center>
        <div class="step" v-if="expreform.dioType == 'add'">
          <div class="item" :class="{'activeStep' : expreform.Step == 1}">1、绑定设备</div>
          <div class="item" :class="{'activeStep' : expreform.Step == 2}">2、绑定快递员</div>
        </div>
        <template v-if="expreform.Step == 1 && expreform.dioType == 'add'">
        <div class="contDio minH300 mt20">
          <div class="tit flex">
            <div>绑定设备：</div>
          </div>
          <div class="authUserList flex">
            <div class="userTree">
              <div class="titSub">空间列表</div>
              <el-tree
              ref="tree"
              class="defineTree"
              :data="spaceList"
              highlight-current
              default-expand-all
              node-key="space_id"
              :expand-on-click-node="false"
              :props="treeProps"
              @node-click="getNode">
                <span class="custom-tree-node" slot-scope="{ node,data }">
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span class="label" :class="data.space_id === expreform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">设备列表</div>
              <div class="search pdtb6">
                <el-input size="small" placeholder="请输入设备ID或设备名称" prefix-icon="el-icon-search" v-model="expreform.search" @input="searchInput"></el-input>
              </div>
              <el-radio-group class="groupH" v-model="expreform.device_id">
                <el-radio class="dblock" v-for="(item,index) in deviceList" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="info" @click="expressDio = false">取消</el-button>
          <el-button type="primary" @click="nextStep">下一步</el-button>
        </span>
        </template>
        <template v-else-if="expreform.Step == '2' || expreform.dioType == 'edit'">
        <div class="contDio minH300 mt20">
          <div class="tit flex">
            <div>配置快递员：</div>
            <div class="col6">已选择：{{expreform.user_id.length}}项</div>
          </div>
          <div class="authUserList flex">
            <div class="userTree">
              <div class="titSub">快递公司列表</div>
              <el-tree
              class="defineTree"
              :data="compList"
              highlight-current
              default-expand-all
              node-key="id"
              :expand-on-click-node="false"
              :props="selectProps"
              @node-click="getNode2">
                <span class="custom-tree-node" slot-scope="{ node,data }">
                  <i
                    class="defineIcon"
                    :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                  </i>
                  <span class="label" :class="data.id === expreform.company_id ? 'selectedTree' : ''">{{ data.express_name }}</span>
                </span>
              </el-tree>
            </div>
            <div class="checkList">
              <div class="titSub">快递员列表</div>
              <div class="search pdtb6">
                <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="expreform.search2" @input="searchUser"></el-input>
              </div>
              <el-checkbox class="dblock" :indeterminate="expreform.isIndeterminate" v-model="expreform.checkAll" @change="CheckAllChange">全选</el-checkbox>
              <el-checkbox-group class="groupH" v-model="expreform.user_id" @change="CheckedItemChange">
                <el-checkbox class="dblock" v-for="(item,index) in auditorList" :label="item.id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="prevStep"  v-if="expreform.dioType == 'add'">上一步</el-button>
          <el-button type="info" @click="expressDio = false"  v-if="expreform.dioType == 'edit'">取消</el-button>
          <el-button type="primary" @click="submitConfig()">确定</el-button>
        </span>
        </template>
        
      </el-dialog>
      
      <!--删除配置-->
      <el-dialog title="" :visible.sync="statusDio" class="statusDio">
        <div class="statusCont">
          <div>是否删除该配置？</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="statusDio = false">取 消</el-button>
          <el-button type="primary" @click="delConfig">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { unmanApi,eSiteApi,sceneApi, bussinessApi,userApi } from "../../../../static/js/api.js"
  var vm
  export default {
    name: 'CExConfigSetting',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          device_id:'',
        },

        configList:[],//配置列表
        tableLoading:false,
        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据

        treeProps:{
          label: 'space_name',
          id: 'space_id',
          children: 'children'
        },
        expressDio:false,//弹窗
        expressTitle:'',
        expreform:{
          dioType:'',
          Step:'1',//步骤
          isIndeterminate:false,//全选状态
          checkAll:false,//是否全选
          space_id:'',//当前空间id
          search:'',//设备搜索
          device_id:[],
          company_id:'',//当前快递公司ID
          search2:'',//用户搜索
          user_id:[],//选中的用户
        },
        addform:{
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
        },
        rules:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
        },

        spaceList:[],//空间列表

        allDevice:[],
        deviceList:[],//设备列表
        compList:[],//快递公司列表
        allUser:[],
        auditorList:[],//用户列表
        // 级联选择器配置
        selectProps: {
          label: 'express_name',
          id: 'id',
          children: 'children'
        },

        statusDio:false,
        del_id:'',
      };
    },
    mounted(){

    },
    created: async function () {
      vm = this
      vm.getWarehouse();//获取配置信息
      vm.getSpaceList();//获取空间
      vm.getCompanyList();//获取快递公司
    },
    methods: {
      //上一步
      prevStep(){
        if(vm.expreform.Step == 2){
          vm.expreform.Step = 1
        }
      },
      //下一步
      nextStep(){
        if(vm.expreform.Step == 1){
          if(vm.expreform.device_id == ''){
            showToast('请选择设备')
            return
          }
          vm.courierList()
          vm.expreform.Step = 2
        }
      },
      //全选(添加)
      CheckAllChange(val) {
        var arr = []
        for(var i in this.auditorList){
          arr.push(this.auditorList[i].id)
        }
        arr = Array.from(new Set(arr))
        this.expreform.user_id = val ? arr : [];
        this.expreform.isIndeterminate = false;
      },
      //选择多个(添加)
      CheckedItemChange(value) {
        let checkedCount = value.length;
        vm.expreform.checkAll = checkedCount === vm.auditorList.length;
        vm.expreform.isIndeterminate = checkedCount > 0 && checkedCount < vm.auditorList.length;
      },
      //搜索筛选
      searchInput(){
        var allDevice = this.allDevice
        var searchList = []
        for(var i in allDevice){
          if(vm.expreform.search!=''){
            if(allDevice[i].device_name.indexOf(vm.expreform.search) != -1 || allDevice[i].device_no_id.indexOf(vm.expreform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else{
            searchList = allDevice
          }
        }
        // console.log('searchList',searchList)
        this.deviceList = searchList
      },
      //打开删除弹窗
      openStatus(index){
        this.del_id = this.configList[index].device_no_id
        this.statusDio = true;
      },
      //删除授权用户
      async delConfig(){
        let data = {
          'device_no_id': vm.del_id,//授权用户id
        }
        let res = await bussinessApi.delkdConfig(data)
        if (res.meta.code === 200) {
          vm.getWarehouse(1)
          vm.statusDio = false;
          showToast('删除成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      
      //获取空间父id
      async getSpaceParentSpace(index){
        const data = {
          'space_id':vm.configList[index].space_id
        }
        let res = await unmanApi.getSpaceParentSpace(data)
        if (res.meta.code === 200) {
          vm.editform.space_id = res.data.space_str.split(',')
        } else {
          showToast(res.meta.message)
        }
      },
      //提交配置
      async submitConfig(id){
        if(vm.expreform.user_id == ''){
          showToast('请选择快递员')
          return
        }
        var data = {
          'device_no_id':vm.expreform.device_id,
          'courier_list': vm.expreform.user_id
        }
        const res = await bussinessApi.addkdConfig(data)
        if (res.meta.code === 200) {
          vm.expreform={
            dioType:'',//弹窗类型
            Step:'1',//步骤
            isIndeterminate:false,//全选状态
            checkAll:false,//是否全选
            space_id:'',//当前空间id
            search:'',//设备搜索
            device_id:[],
            company_id:'',//当前快递公司ID
            search2:'',//用户搜索
            user_id:[],//选中的用户
          }
          vm.deviceList=[]
          vm.auditorList=[]
          vm.expressDio = false
          vm.getWarehouse(1)
          showToast('配置成功！')
          
        }else{
          showToast(res.meta.message)
        }
      },
      //打开弹窗
      openDio(type,info){
        vm.expreform.dioType = type
        if(type == 'add'){
          vm.expressTitle = '添加配置'
          vm.expreform={
            dioType:type,
            Step:'1',//步骤
            isIndeterminate:false,//全选状态
            checkAll:false,//是否全选
            space_id:'',//当前空间id
            search:'',//设备搜索
            device_id:[],
            company_id:'',//当前快递公司ID
            search2:'',//用户搜索
            user_id:[],//选中的用户
          }
          let space_id = this.expreform.space_id = this.spaceList[0].space_id
          vm.getSpaceDeviceKd(space_id)
        }else if(type == 'edit'){
          vm.expressTitle = '配置快递员'
          vm.expreform.device_id = info.device_no_id
          vm.expreform.user_id = info.user_id
          vm.courierList()
        }
        vm.expressDio = true
      },
      //获取空间列表
      async getSpaceList(){
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          vm.spaceList = [...res.data]
          // vm.processScene(res.data) // 汕头移动需注释
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
              // console.log('area', area, list[s].space_name)
            for (let i in area) {
              let street = area[i].children
              // console.log('street', street, area[i].space_name)
              for (let j in street) {
                let company = street[j]
                // console.log('company', company, company.space_name )
                vm.spaceList.push(company)
              }
            }
          }
        }

      },
      //同步设备类型
      getDeviType2(type){
        for(let i in this.deviceList){
          if(type == 2){
            if(vm.deviceList[i].device_no_id == this.editform.device_id){
              vm.editform.type = vm.deviceList[i].device_type
              vm.editform.device_name = vm.deviceList[i].device_name
            }
          }else{
            if(vm.deviceList[i].device_no_id == this.addform.device_id){
              vm.addform.type = vm.deviceList[i].device_type
              vm.addform.device_name = vm.deviceList[i].device_name
            }
          }
          
        }
      },
      //获取树形节点(添加)
      getNode(node){
        this.expreform.space_id = node.space_id
        //调用获取设备列表的接口
        this.getSpaceDeviceKd(node.space_id)
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.space_id,this.addform.sizeCheck)
      },
      //获取树形节点(修改)
      getNode2(node){
        this.expreform.company_id = node.id
        //调用获取用户的接口
        this.courierList(node.id)
      },
      //通过快递公司id获取快递员列表
      async courierList(space_id){
        const data = {
          'page':1,
          'perPage':999999,
          'express_company_id': space_id,
        }
        const res = await bussinessApi.kdCourierList(data)
        if(res.meta.code == 200){
          vm.allUser = res.data.list
          vm.searchUser()
        }else{
          showToast(res.meta.message)
        }
      },
      //搜索筛选
      searchUser(){
        var allUser = this.allUser
        var searchList = []
        for(var i in allUser){
          if(vm.expreform.search2!=''){
            if(allUser[i].user_name.indexOf(vm.expreform.search2) != -1 || allUser[i].phone_no.indexOf(vm.expreform.search2) != -1){
              searchList.push(allUser[i])
            }
          }else{
            searchList = allUser
          }
        }
        // console.log('searchList',searchList)
        this.auditorList = searchList
      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceKd(space_id){
        const data = {
          'space_id': space_id,
        }
        const res = await bussinessApi.getSpaceDeviceKd(data)
        if(res.meta.code == 200){
          vm.allDevice = res.data
          vm.deviceList = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //获取快递公司列表
      async getCompanyList(){
        const data = {
          'page':1,//当前页
          'perPage': 999999,//每页条数
        }
        let res = await bussinessApi.GetExpress(data)
        if(res.meta.code == 200){
          var _arr = [{
            id:'',
            express_name:'全部',
            children:res.data.list
          }]
          vm.compList = _arr
          console.log(vm.compList)
        }else{
          showToast(res.meta.message)
        }
      },
      
      //获取配置设置列表
      async getWarehouse(curr,limits){
        this.tableLoading = true
        const data = {
          'page':curr ? curr : vm.curr,//当前页
          'perPage': limits ? limits : vm.page,//每页条数
          'device_id': vm.keyword.device_id,//设备id
        }
        let res = await bussinessApi.kdConfigList(data)
        if(res.meta.code == 200){
          vm.configList = res.data.list
          vm.total = parseInt(res.data.total)
          vm.tableLoading = false
        }else{
          vm.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getWarehouse(val)
      },
      sizeChange (val) {
        console.log('val', val)
        this.page = val
        this.getWarehouse(1)
      },
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      },
      
    }
  }
</script>

<style lang="scss">
.CExConfigSetting{
  .expressDio{
    .titSub{
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      background: #E8E8E8;
      color: #333;
      box-sizing: border-box;
    }
    .tips{
      color: #999;
      padding: 15px 0;
    }
    .step{
      padding: 0;
      height: 30px;
      margin: 0 33px 0 18px;
      background: #DADADA;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .item{
        width: 50%;
        font-size: 12px;
        color: #fff;
        line-height: 30px;
        text-align: center;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          right: -30px;
          top: 0;
          width: 0;
          height: 0;
          border-width: 15px;
          border-style: solid;
          border-color: transparent transparent transparent #DADADA;
          z-index: 10;
        }
        &.activeStep{
          background: #4BABFE;
          &::after{
            border-color: transparent transparent transparent #4BABFE;
          }
        }
      }
    }
  }
  .previewDio{
    .tr{
      text-align: right;
      el-button{
        display: inline-block;
        line-height: 1;
        padding: 12px 20px;
        border:1px solid #DCDFE6;
        font-size: 14px;
        color: #606266;
        border-radius: 4px;
      }
    }
    .img{
      width: 200px;
      width: 200px;
      margin: 0px auto;
      padding: 20px;
      img{ width:100%; }
    }
  }
  
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .contDio{
    .el-select{ display:block;}
  }
  .configDio{
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #979797;
      align-items: flex-start !important;
      .userTree{
        width: 44%;
        height: 330px;
        overflow-y: auto;
        border-right: 1px solid #979797;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          // text-align: center;
          padding: 6px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input{
            width: 50%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
          .sizeDiv{
            margin-left: 10px;
            .el-checkbox,.el-radio{
              margin-right: 10px;
            }
          }
          &.pdtb6{
            padding: 6px 0;
          }
        }
        .el-checkbox.dblock,.el-radio.dblock{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label,.el-radio__label{
            padding-left:16px;
          }
        }
        .el-checkbox-group.groupH{
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
        .el-radio-group.groupH{
          display: block;
          height: 256px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .redSetting{
      padding: 10px;
      border: 1px solid #979797;
      border-top: none;
      .tit {
        padding-left: 0;
        color: #999999;
      }
      .des {
        display: flex;
        align-items: center;
        .el-input-number {
          width: 100px;
          margin: 0 5px;
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .checkItem{
            width: 33.33%;
            .el-checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CExpress/CExConfigSetting.vue